<div class="tis-login-page">
    <div class="tis-login-container">
        <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
            <div class="tis-login-header">
                <div class="login-logo">
                    <img alt="logo2" src="assets/logo/cantrak-logo.svg">
                </div>
                <div class="tis-language-selection">
                    <span class="text-sm tis-text-primary">Select Language</span>
                    <ul>
                        <li>
                            <a id="engLang" class="eng_font tis-curser-pointer">
                                <img src="/assets/icons/en.png" alt="" class="mr-2 w-7 h-7 rounded-full">
                            </a>
                        </li>
                        <li>
                            <a id="thLang" class="thai_font tis-curser-pointer">
                                <img src="/assets/icons/th.png" alt="" class="mr-2 w-7 h-7 rounded-full">
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="tis-login-body">
                <mat-form-field class="tis-mat-form-field" appearance="outline">
                    <mat-label>Email/Mobile/Username</mat-label>
                    <input matInput placeholder="Email/Mobile/Username" formControlName="username">
                    @for (validation of validationMessages.username; track validation.type) {
                        <mat-error *ngIf="forgotPasswordForm.get('username')?.hasError(validation.type) && (forgotPasswordForm.get('username')?.dirty || forgotPasswordForm.get('username')?.touched)">{{validation.message}}</mat-error>
                    }
                </mat-form-field>
            </div>
            <div class="tis-login-footer">
                <ul>
                    <li>
                        <a class="tis-a" [routerLink]="['/login']">Back to Login</a>
                    </li>
                </ul>
                <div class="tis-footer-action">
                    <button mat-flat-button class="tis-btn-filled-primary w-full">
                        Send Password Recovery Email
                        <i class="fas fa-spinner fa-spin" *ngIf="formLoading"></i>
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>